import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
  selector: 'vui-desktop-icon',
  templateUrl: './desktop-icon.component.html'
})
export class DesktopIconComponent extends AbstractIcon {
  constructor() {
      super();
      this.height = 24;
      this.width = 26;
  }
}
